/* CW custom-print PDP helpers: Zakeke loading state, quote link variant carry, focus links, analytics (OFF). */
(function () {
  'use strict';
  var CW_QUOTE_ANALYTICS = false; // stays false until a receiver + consent handling are verified; never sends PII
  function emit(name, payload) {
    if (!CW_QUOTE_ANALYTICS) return;
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, payload); } catch (e) { /* no-op */ }
  }
  // Zakeke injects #zakeke-product-button-custom late; CSS reserves the slot + shows "Loading design tool…".
  function zkReady() { return document.getElementById('zakeke-product-button-custom'); }
  var slot = document.querySelector('.product__info-container > .custom-liquid:not(:has(.cwcb))');
  if (slot && !zkReady()) {
    var t0 = setTimeout(function () { if (!zkReady()) slot.classList.add('cwcb-zk-slow'); }, 10000); // CSS keeps watching via :has
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function () { if (zkReady()) { clearTimeout(t0); slot.classList.remove('cwcb-zk-slow'); mo.disconnect(); } });
      mo.observe(slot, { childList: true, subtree: true });
    }
  }

  // Keep the quote links carrying the currently selected variant.
  function currentVariantId() {
    var picker = document.querySelector('variant-radios, variant-selects');
    var sec = picker ? picker.closest('section, .shopify-section') : null;
    var input = sec ? sec.querySelector('form[id^="product-form"] input[name="id"]') : null;
    var q = new URLSearchParams(location.search).get('variant');
    return (input && input.value) || q || '';
  }
  function syncQuote() {
    var v = currentVariantId();
    document.querySelectorAll('[data-cwcb-quote],[data-cwcp-quote]').forEach(function (a) {
      try { var u = new URL(a.getAttribute('href'), location.origin); if (v) u.searchParams.set('variant', v); a.setAttribute('href', u.pathname + u.search); } catch (e) { /* keep original */ }
    });
  }
  var picker = document.querySelector('variant-radios, variant-selects');
  if (picker) picker.addEventListener('change', function () { setTimeout(syncQuote, 150); });
  window.addEventListener('popstate', function () { setTimeout(syncQuote, 150); });
  syncQuote();

  // "You're here — start customizing" focuses the design-tool button.
  document.querySelectorAll('[data-cwcp-focus]').forEach(function (a) {
    a.addEventListener('click', function (ev) { var b = zkReady(); if (b) { ev.preventDefault(); b.scrollIntoView({ block: 'center' }); b.focus(); } });
  });

  // Analytics hooks (disabled): impression + click on quote CTAs; no personal data.
  var method = (document.querySelector('[data-cwcp]') || {}).getAttribute ? document.querySelector('[data-cwcp]').getAttribute('data-method') : '';
  document.querySelectorAll('[data-cwcb-quote],[data-cwcp-quote]').forEach(function (a, i) {
    a.addEventListener('click', function () { emit('cw_quote_cta_click', { method: method, slot: i }); });
    if (CW_QUOTE_ANALYTICS && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { emit('cw_quote_cta_impression', { method: method, slot: i }); io.disconnect(); } }); }, { threshold: 0.5 });
      io.observe(a);
    }
  });
})();
